import {
  GET_CLIENT_SUMMARY_YJC,
  GET_CLIENT_SUMMARY_YJC_SUCCESS,
  SAVE_CLIENT_SUMMARY_YJC,
  CLIENT_SUMMARY_YJC_ERROR,
} from './types';

const initialState = {
  item: null,
  notifications: [],
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default function initState(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_CLIENT_SUMMARY_YJC:
    case SAVE_CLIENT_SUMMARY_YJC:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_CLIENT_SUMMARY_YJC_SUCCESS:
      return {
        ...state,
        loading: false,
        item: payload,
      };

    case CLIENT_SUMMARY_YJC_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
}
